import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import Container from 'components/container';
import ResetPasswordForm from './ResetPasswordForm';
import OnboardingStore from 'modules/onboarding/OnboardingStore';

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount = () => {
        OnboardingStore.on('change', this.onStateChange);
    };

    componentWillUnmount = () => {
        OnboardingStore.removeListener('change', this.onStateChange);
    };

    onStateChange = (loading, reset) => {
        if (reset) {
            //redirect to login
            this.props.history.push('/login');
        }
        this.setState({ loading: loading });
    };

    render() {
        return (
            <div className="login-page page">
                <Container transparent fluid>
                    <div className="login-form-wrapper">
                        <ResetPasswordForm
                            loading={this.state.loading}
                            token={this.props.match.params.token}
                        />
                    </div>
                </Container>
            </div>
        );
    }
}

export default withRouter(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/reset-password/ResetPasswordPage.jsx